import qs from 'qs'

export default {
    namespaced: true,
    state: {
        shops_list: {},
        message: "",
        terms: []
    },
    mutations: {
        set_shops_list(state, data) {
            state.shops_list = data;
        },
        set_message(state, message) {
            state.message = message;
        },
        set_terms(state, terms) {
            state.terms = terms
        }
    },
    actions: {
        async shop_terms({commit, state}) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'shopTerms',
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                console.log(res)
                if (res.status === 200) {
                    commit("set_terms", res.data.data)
                }
            }).catch((e) => {
                console.log('error')
            })
        },
        async search_shops({commit, state}, data) {
            let parameters = {
                action: 'displayShopList',
                search_string: data["search_string"],
                term_id: data["term_id"],
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                if (res.status === 200) {
                    commit("set_shops_list", res.data.data.shops)
                    commit("set_message", res.data.data.message)
                }
            }).catch((e) => {
                console.log('error')
            })
        }
    },
    getters: {
        get_shops_list: (state) => state.shops_list,
        get_message: (state) => state.message,
        get_terms: (state) => state.terms
    }
};